const sendPageView = (location) => {
  if (typeof ga !== 'undefined') {
    // eslint-disable-next-line no-undef
    ga('set', 'page', location);
    // eslint-disable-next-line no-undef
    ga('send', 'pageview');
  }
};

// eslint-disable-next-line import/prefer-default-export
export { sendPageView };



// WEBPACK FOOTER //
// ./utils/helpers/ga.js